import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Button = _resolveComponent("Button")
  const _component_QBEOperator = _resolveComponent("QBEOperator")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "qbe-advanced-filter-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.QBEAdvancedFilterDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('qbe.advancedFilters.advancedFilterVisualisation')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary qbe-advanced-filter-button p-m-2",
          disabled: _ctx.selectedCount < 2,
          onClick: _ctx.group
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('qbe.advancedFilters.group')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary qbe-advanced-filter-button p-m-2",
          disabled: !_ctx.singleGroupSelected,
          onClick: _ctx.ungroup
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('qbe.advancedFilters.ungroup')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      (_ctx.expression)
        ? (_openBlock(), _createBlock(_component_QBEOperator, {
            key: 0,
            propNode: _ctx.root,
            onSelectedChanged: _ctx.onSelectedChanged,
            onTreeUpdated: _ctx.onTreeUpdated
          }, null, 8, ["propNode", "onSelectedChanged", "onTreeUpdated"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}